import React from "react";

import { countries } from "../utils/countries";
import AutocompleteField from "../AutocompleteField";
import { CountryFieldProps } from "./CountryField.types";

const options = countries.map((country) => country.name);

function CountryField(props: CountryFieldProps): JSX.Element {
  const { value } = props;

  return (
    <AutocompleteField {...props} value={value || null} options={options} />
  );
}

export default CountryField;
